'use client'

import { LocalizedLink } from '@src/components/LocalizedLink/LocalizedLink'
import { useTopNav } from '@src/components/TopNavV3/TopNavContext'
import { useTrackSelectNavCta } from '@src/utils/analytics.util'

export const TopNavMobileFooter = () => {
  const trackSelectNavCta = useTrackSelectNavCta()
  const { mobileFooterLinks, setExpanded } = useTopNav()

  return (
    <footer className="flex flex-col gap-3 border-t border-white/10 p-4 pt-8 text-bodi-gray-butters">
      {mobileFooterLinks
        ?.filter((item) => Boolean(item.title))
        .map((item) => (
          <LocalizedLink
            onClick={() => {
              trackSelectNavCta({ 'cta url': item.href })
              setExpanded(false)
            }}
            key={item?.title}
            href={item.href ?? ''}
            rel={item.newTab ? 'noopener noreferrer' : ''}
            target={item.newTab ? '_blank' : '_self'}
          >
            {item.title}
          </LocalizedLink>
        ))}
    </footer>
  )
}
